import React, { useState, useEffect } from 'react';
import devuelveReglamentoSanciones from './devuelveReglamentoSanciones';
import './piton.css';
import axios from 'axios';
import ObtieneDatosCookies from '../obtieneDatosCookiesUsuario';
import Swal from "sweetalert2";
import socket from '../tools/socke';

const SelectorCantidadSancion = ({ sancion, valores }) => {

  const Usuario = ObtieneDatosCookies();
  const sanciones = devuelveReglamentoSanciones();

  const valorOriginal = parseFloat(sancion.cantidad) || 0;

  const [selectedSancion, setSelectedSancion] = useState(sancion.articulo);
  const [selectedInciso, setSelectedInciso] = useState(sancion.inciso.toString());
  const [opcionSeleccionada, setOpcionSeleccionada] = useState(valorOriginal);
  const [elMinimo, setElMinimo] = useState(0);
  const [elMaximo, setElMaximo] = useState(0);

  /* =====================================
     REGLA DISCIPLINARIA
     - No puede superar la mitad
     - Redondeo hacia abajo
     - Caso especial 1 → 0.5 permitido
  ====================================== */
  useEffect(() => {

    if (valorOriginal > 1) {

      const mitad = Math.floor(valorOriginal / 2);

      const minimoCalculado = valorOriginal - mitad;
      const maximoCalculado = valorOriginal + mitad;

      setElMinimo(minimoCalculado);
      setElMaximo(maximoCalculado);

      if (opcionSeleccionada < minimoCalculado || opcionSeleccionada > maximoCalculado) {
        setOpcionSeleccionada(valorOriginal);
      }

    } 
    else if (valorOriginal === 1) {
      // Caso especial: puede bajar a apercibimiento (0.5)
      setElMinimo(0.5);
      setElMaximo(1);
    } 
    else {
      setElMinimo(0);
      setElMaximo(0);
    }

  }, [valorOriginal]);

  /* =====================================
     GENERADOR DE RANGO
     Soporta 0.5 como apercibimiento
  ====================================== */
  const rango = (min, max) => {
    const valores = [];

    if (min === 0.5) {
      valores.push(0.5);
      min = 1;
    }

    for (let i = min; i <= max; i++) {
      valores.push(i);
    }

    return valores;
  };

  const resultadoRango = rango(elMinimo, elMaximo);

  /* =====================================
     SUBMIT
  ====================================== */
  const creaSancionForm = async (e) => {
    e.preventDefault();

    if (!selectedSancion || !selectedInciso || opcionSeleccionada === null) {
      Swal.fire({
        title: "Error",
        text: "Todos los campos deben estar completos.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    // 🔒 Blindaje extra
    if (opcionSeleccionada < elMinimo || opcionSeleccionada > elMaximo) {
      Swal.fire({
        title: "Error",
        text: "El valor seleccionado está fuera del rango permitido.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    const datos = {
      cantidadConfirma: parseFloat(opcionSeleccionada),
      resuelveUsuarioControla:
        opcionSeleccionada > valorOriginal ? "Aumentar" : "Disminuir",
      usuarioControla: `${Usuario.nombre} ${Usuario.apellido}`,
      idUsuarioControla: Usuario.id,
      fechaConfirma: new Date(),
      estado: "Confirmada"
    };

    const username = process.env.REACT_APP_KEY;
    const password = process.env.REACT_APP_PASS;
    const token = btoa(`${username}:${password}`);

    try {
      const response = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/NCadetes/actualizaSancion/${sancion.id}`,
        datos,
        {
          headers: { Authorization: `Basic ${token}` },
        }
      );

      if (response.data.success) {
        Swal.fire({
          title: "Sanción Confirmada con éxito",
          text: `Se confirmó una sanción para el cadete con DNI ${sancion.cadeteDni}`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          socket.emit("sancionEvent", "");
          valores(datos);
        });
      } else {
        Swal.fire({
          title: response.data.message,
          text: "Compruebe los datos, algo pudo salir mal.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }

    } catch (error) {
      Swal.fire({
        title: "Error",
        text: "Falló la generación, compruebe si el cadete existe.",
        icon: "error",
        confirmButtonText: "OK",
      });
//       console.log('Error al enviar los datos:', error);
    }
  };

  const handleSancionChange = (e) => {
    setSelectedSancion(e.target.value);
    setSelectedInciso('');
  };

  const selectedSancionData =
    sanciones.find((s) => s.id === selectedSancion) || {};

  const incisos = selectedSancionData.Incisos || [];

  return (
    <>
      <form className='formLuis' onSubmit={creaSancionForm}>

        <label>Sanción:</label>
        <select
          disabled
          className={`form-control ${selectedSancion ? "is-valid" : "is-invalid"}`}
          onChange={handleSancionChange}
          value={selectedSancion}
        >
          <option value="">-- Selecciona --</option>
          {sanciones.map((sancionItem) => (
            <option key={sancionItem.id} value={sancionItem.id}>
              {sancionItem.id} - {sancionItem.descripcion}
            </option>
          ))}
        </select>

        <label>Inciso:</label>
        <select
          disabled
          className={`form-control ${selectedInciso ? "is-valid" : "is-invalid"}`}
          value={selectedInciso}
          onChange={(e) => setSelectedInciso(e.target.value)}
        >
          <option value="">Selecciona...</option>
          {incisos.map((inciso, index) => {
            const clave = Object.keys(inciso)[0];
            const valor = Object.values(inciso)[0];
            return (
              <option key={index} value={`${clave} - ${valor}`}>
                {clave} - {valor.length > 100 ? valor.substring(0, 100) + "..." : valor}
              </option>
            );
          })}
        </select>

        <textarea
          className="textArea"
          value={selectedInciso ? selectedInciso.split(' - ')[1] : ''}
          disabled
          rows="3"
        />

        <label>Cantidad:</label>
        <select
          className={`form-control ${opcionSeleccionada ? "is-valid" : "is-invalid"}`}
          value={opcionSeleccionada}
          onChange={(e) => setOpcionSeleccionada(parseFloat(e.target.value))}
        >
          <option value="">Selecciona...</option>
          {resultadoRango.map((valor, index) => (
            <option key={index} value={valor}>
              {valor === 0.5 ? "Apercibimiento" : valor}
            </option>
          ))}
        </select>

        <button className='btn btn-success'>
          Confirmar Modificación
        </button>

      </form>
    </>
  );
};

export default SelectorCantidadSancion;